export default {
  GET_LAYOUTS: "GET_LAYOUTS",
  SAVE_LAYOUTS: "SAVE_LAYOUTS",
};
